import { useState, useEffect } from "react";
import { clearMember } from "../redux/slices/Member/member";
import { Storage } from "../utils/storage";
import { useAppDispatch, useAppSelector } from ".";
import * as auth0Client from "../utils/auth0Client";

export default function useAuthenticate(check = true): boolean {
  const dispatch = useAppDispatch();
  const memberLoggedIn = useAppSelector((state) => state.member.isLoggedIn);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    const checkAuthentication = async () => {
      const authenticated = auth0Client.isAuthenticated();
      const isAuthenticatedFromCache =
        Storage.GetLocalStorageValue("auth-token");
      if (!authenticated || !isAuthenticatedFromCache) {
        await dispatch(clearMember());
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    };

    if (memberLoggedIn) {
      checkAuthentication();
    }
  }, [memberLoggedIn, isAuthenticated, check]);

  return isAuthenticated;
}
